import Vue from 'vue'
import Router from 'vue-router'
import {main} from './mod/main.route'
import {auth} from './mod/auth.route'
import {reg} from './mod/reg.route'
import {bind} from './mod/bind.route'
import {user} from './mod/user.route'
import {patientMeal} from './mod/patientMeal.route'
import {activity} from './mod/activity.route'
import {specialClinic} from './mod/specialClinic.route'
import {inoutHospital} from './mod/inoutHospital.route'
import {mes} from './mod/mes.route'
import {prettyTibet} from './mod/prettyTibet.route'
import {PackagesIntroNav} from './mod/packagesIntro.route'
import {introduce} from './mod/introduce.route'
import {recovery} from './mod/recovery.route'
import {nuclein} from './mod/nuclein.route'
import {preDiagnosis} from './mod/preDiagnosis.route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/m/',
  routes: [
    ...auth,
    ...main,
    ...reg,
    ...bind,
    ...user,
    ...patientMeal,
    ...specialClinic,
    ...inoutHospital,
    ...activity,
    ...mes,
    ...prettyTibet,
    ...PackagesIntroNav,
    ...introduce,
    ...recovery,
    ...nuclein,
    ...preDiagnosis,
    {path: '*', redirect: '/login'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js